import React from 'react';
import './styles.css';

const FiltersWidget = props => {
  const {
    title,
    subTitle,
    accordions,
    topWidget,
    disabled,
    onClearAllWithSelection,
    onResetToDefault,
  } = props;

  return (
    <div className="filter-accordion__widget">
      <div className="filters-accordion__header">
        <h4 className="filters-accordion__title">{title}</h4>
        {subTitle && (
          <p className="filters-accordion__description">{subTitle}</p>
        )}
      </div>
      <div className="filters-accordion__filters-list">
        {topWidget && (
          <div className="filters-accordion__top-widget">{topWidget}</div>
        )}
        {accordions}
        <div className="filters-accordion__filters-controls">
          {onResetToDefault && (
            <button
              type="button"
              className="filters-accordion__filters-reset-btn"
              onClick={disabled ? () => {
              } : onResetToDefault}
            >
              <span className="filters-accordion__btn-icon"/>
              Reset To Default
            </button>
          )}
          <button
            type="button"
            className="filters-accordion__filters-reset-btn"
            onClick={disabled ? () => {
            } : onClearAllWithSelection}
          >
            <span className="filters-accordion__btn-icon"/>
            Clear filters
          </button>
        </div>
      </div>
    </div>
  );
};

export default FiltersWidget;
